@let icon = $icon();
@let iconPosition = $iconPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ?
'items-start' : 'items-end';
<button
  [class]="'flex justify-center w-full' + (iconPosition === 'left' || iconPosition === 'right' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding() | cssValue" [style.gap]="$gap() | cssValue" [disabled]="$disabled()"
  [matTooltip]="!$disabled() ? $tooltip() : $tooltipWhenDisabled()">
  @if (icon !== null) {
  <app-icon [icon]="icon" [color]="$iconColor()" [size]="$iconSize()" [scale]="$iconScale()"
    [rotation]="$iconRotation()" [rotationDelay]="$iconRotationDelay()" [viewBoxAdjustmentX]="$iconViewBoxAdjustmentX()"
    [viewBoxAdjustmentY]="$iconViewBoxAdjustmentY()"
    [class]="$iconPosition() === 'left' || $iconPosition() === 'top' ? 'order-0' : 'order-1'" />
  }
  @if ($text() !== null) {
  <span class="flex items-center" [style.top]="$textTop()" [style.right]="$textRight()" [style.bottom]="$textBottom()"
    [style.left]="$textLeft()">
    <label [class]="'select-none ' + ($textWrap() ? '' : 'whitespace-nowrap')" [style.fontSize]="$textFontSize() | cssValue"
      [style.fontWeight]="$textWeight()" [style.color]="'var(' + $textColor() + ')'">{{ $text() }}</label>
    @if ($activeIndicator()) {
    <span class="active-indicator" [style.backgroundColor]="$activeIndicatorColor() | cssValue"></span>
    }
  </span>
  }
</button>
